module.exports = __webpack_public_path__ + "img/users.19ca1327.svg";